/** Web can't lock orientation; see usePhoneOrientation for web layouts. */
export const lockPortrait = () => { };
export const unlockOrientation = () => { };
